import React, { useState, useRef, useEffect } from 'react';
import './SearchBarGroup.css';
import { useTranslation } from "react-i18next";

// ── Toutes les villes de Tunisie ────────────────────────────────────────────
const TUNISIAN_CITIES = [
  "Tunis", "Sfax", "Sousse", "Kairouan", "Bizerte", "Gabès", "Ariana",
  "Gafsa", "Monastir", "Ben Arous", "Kasserine", "Médenine", "Nabeul",
  "Tataouine", "Béja", "Jendouba", "Mahdia", "Sidi Bouzid", "Siliana",
  "Zaghouan", "Tozeur", "Kebili", "Manouba", "La Marsa", "La Goulette",
  "Hammamet", "Djerba", "Zarzis", "El Kef", "Tabarka", "Douz",
  "Nefta", "Sbeitla", "Kalaa Kebira", "Korba", "Mateur", "Menzel Bourguiba",
  "Msaken", "Moknine", "Ksar Hellal", "Chebba", "Agareb", "El Aïoun",
  "Sidi Hafiene", "Regueb", "Mezzouna", "Ben Guerdane", "Remada",
  "Dehiba", "Bir Lahmar", "Ghomrassen", "Beni Khiar", "Dar Chaabane",
  "El Haouaria", "Kelibia", "Grombalia", "Soliman", "Bou Argoub",
  "Enfida", "Akouda", "Hammam Sousse", "Chott Meriem", "Sidi Bou Ali",
  "Ouardanine", "Zeramdine", "Bembla", "Sahline", "Menzel Kamel",
  "Teboulba", "Bekalta", "Ksour Essaf", "El Djem", "Sidi Alouane",
  "Bou Merdes", "Ghennouch", "El Hamma", "Métouia", "Mareth",
  "Menzel Habib", "Ghanouch", "Bir Ali Ben Khalifa", "Gremda",
  "Sakiet Ezzit", "Chihia", "El Amra", "Moulares", "Redeyef",
  "El Guettar", "Belkhir", "Zannouch", "Sened", "El Ksar",
  "Sbiba", "Thala", "Feriana", "Foussana", "Hassi El Ferid",
  "Rohia", "Makther", "El Aroussa", "Kesra", "Bargou",
  "Djebba", "Testour", "Medjez El Bab", "Nefza", "Amdoun",
  "Fernana", "Ghardimaou", "Bou Salem", "Ain Draham",
];

// ── Toutes les spécialités médicales ────────────────────────────────────────
const SPECIALTIES = [
  { id: "all",               label: "Toutes les spécialités" },
  { id: "generalPractice",   label: "Médecine Générale" },
  { id: "cardiology",        label: "Cardiologie" },
  { id: "dermatology",       label: "Dermatologie" },
  { id: "pediatrics",        label: "Pédiatrie" },
  { id: "orthopedics",       label: "Orthopédie" },
  { id: "neurology",         label: "Neurologie" },
  { id: "psychiatry",        label: "Psychiatrie" },
  { id: "ophthalmology",     label: "Ophtalmologie" },
  { id: "ent",               label: "ORL (Oto-Rhino-Laryngologie)" },
  { id: "gynecology",        label: "Gynécologie" },
  { id: "dentistry",         label: "Dentisterie" },
  { id: "urology",           label: "Urologie" },
  { id: "nephrology",        label: "Néphrologie" },
  { id: "gastroenterology",  label: "Gastro-entérologie" },
  { id: "pulmonology",       label: "Pneumologie" },
  { id: "endocrinology",     label: "Endocrinologie" },
  { id: "rheumatology",      label: "Rhumatologie" },
  { id: "oncology",          label: "Oncologie" },
  { id: "hematology",        label: "Hématologie" },
  { id: "infectiology",      label: "Infectiologie" },
  { id: "allergy",           label: "Allergologie" },
  { id: "immunology",        label: "Immunologie" },
  { id: "anesthesia",        label: "Anesthésiologie" },
  { id: "radiology",         label: "Radiologie" },
  { id: "nuclearMedicine",   label: "Médecine Nucléaire" },
  { id: "pathology",         label: "Anatomopathologie" },
  { id: "emergencyMedicine", label: "Médecine d'Urgence" },
  { id: "geriatrics",        label: "Gériatrie" },
  { id: "palliativeCare",    label: "Soins Palliatifs" },
  { id: "physicalMed",       label: "Médecine Physique et Réadaptation" },
  { id: "sportsMedicine",    label: "Médecine du Sport" },
  { id: "vascularSurgery",   label: "Chirurgie Vasculaire" },
  { id: "cardiacSurgery",    label: "Chirurgie Cardiaque" },
  { id: "thoracicSurgery",   label: "Chirurgie Thoracique" },
  { id: "neurosurgery",      label: "Neurochirurgie" },
  { id: "plasticSurgery",    label: "Chirurgie Plastique" },
  { id: "digestiveSurgery",  label: "Chirurgie Digestive" },
  { id: "urologicSurgery",   label: "Chirurgie Urologique" },
  { id: "pediatricSurgery",  label: "Chirurgie Pédiatrique" },
  { id: "maxillofacial",     label: "Chirurgie Maxillo-Faciale" },
  { id: "obstetrics",        label: "Obstétrique" },
  { id: "neonatology",       label: "Néonatologie" },
  { id: "geneticsMed",       label: "Génétique Médicale" },
  { id: "nutrition",         label: "Nutrition et Diététique" },
  { id: "stomatology",       label: "Stomatologie" },
  { id: "orthodontics",      label: "Orthodontie" },
  { id: "dermatologySurgery",label: "Dermatologie-Chirurgie" },
  { id: "hepatology",        label: "Hépatologie" },
  { id: "angiology",         label: "Angiologie" },
  { id: "diabetology",       label: "Diabétologie" },
];

// ── Hook générique pour autocomplete ────────────────────────────────────────
function useAutocomplete(items, getLabel) {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
        setHighlightedIndex(-1);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (value) => {
    setInputValue(value);
    if (value.trim() === '') {
      setSuggestions([]);
      setIsOpen(false);
      return;
    }
    const q = value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const filtered = items.filter(item => {
      const label = getLabel(item).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return label.includes(q);
    });
    setSuggestions(filtered);
    setIsOpen(filtered.length > 0);
    setHighlightedIndex(-1);
  };

  const handleKeyDown = (e, onSelect) => {
    if (!isOpen) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex(i => Math.min(i + 1, suggestions.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex(i => Math.max(i - 1, 0));
    } else if (e.key === 'Enter' && highlightedIndex >= 0) {
      e.preventDefault();
      const selected = suggestions[highlightedIndex];
      const label = getLabel(selected);
      setInputValue(label);
      setIsOpen(false);
      onSelect(selected);
    } else if (e.key === 'Escape') {
      setIsOpen(false);
    }
  };

  const selectItem = (item, onSelect) => {
    const label = getLabel(item);
    setInputValue(label);
    setIsOpen(false);
    setHighlightedIndex(-1);
    onSelect(item);
  };

  return { inputValue, setInputValue, suggestions, isOpen, highlightedIndex, wrapperRef, handleChange, handleKeyDown, selectItem };
}

// ── Composant principal ──────────────────────────────────────────────────────
const SearchBarGroup = ({
  searchQuery,
  setSearchQuery,
  location,
  setLocation,
  specialty,
  setSpecialty,
  onSearch
}) => {
  const { t } = useTranslation();

  // Autocomplete — Ville
  const cityAC = useAutocomplete(TUNISIAN_CITIES, city => city);

  // Autocomplete — Spécialité
  const specAC = useAutocomplete(SPECIALTIES, s => {
    // Essaie d'abord la traduction i18n, fallback sur label anglais
    const key = `doctorFinder.specialties.${s.id}`;
    const translated = t(key);
    return translated !== key ? translated : s.label;
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  // Sync les valeurs vers le parent quand vide
  useEffect(() => {
    if (cityAC.inputValue === '') setLocation('');
  }, [cityAC.inputValue]);

  useEffect(() => {
    if (specAC.inputValue === '') setSpecialty('');
  }, [specAC.inputValue]);

  return (
    <div className="search-bar-group">
      <form className="search-form" onSubmit={handleSubmit}>

        {/* ── Recherche libre ── */}
        <div className="search-input-wrapper">
          <svg className="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zM19 19l-4.35-4.35"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <input
            type="text"
            className="search-input"
            placeholder={t("doctorFinder.searchPlaceholder")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* ── Autocomplete Ville ── */}
        <div className="ac-wrapper" ref={cityAC.wrapperRef}>
          <div className="location-input-wrapper">
            <svg className="location-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10 1.25c-3.5 0-6.25 2.75-6.25 6.25 0 4.69 6.25 11.25 6.25 11.25s6.25-6.56 6.25-11.25c0-3.5-2.75-6.25-6.25-6.25z"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <input
              type="text"
              className="location-input"
              placeholder={t("doctorFinder.locationPlaceholder")}
              value={cityAC.inputValue}
              onChange={(e) => cityAC.handleChange(e.target.value)}
              onKeyDown={(e) => cityAC.handleKeyDown(e, (city) => setLocation(city))}
              autoComplete="off"
            />
            {cityAC.inputValue && (
              <button
                type="button"
                className="ac-clear-btn"
                onClick={() => { cityAC.setInputValue(''); setLocation(''); }}
                aria-label="Effacer"
              >×</button>
            )}
          </div>
          {cityAC.isOpen && (
            <ul className="ac-dropdown" role="listbox">
              {cityAC.suggestions.map((city, idx) => (
                <li
                  key={city}
                  role="option"
                  aria-selected={idx === cityAC.highlightedIndex}
                  className={`ac-item${idx === cityAC.highlightedIndex ? ' ac-item--highlighted' : ''}`}
                  onMouseDown={() => cityAC.selectItem(city, (c) => setLocation(c))}
                  onMouseEnter={() => cityAC.highlightedIndex !== idx && null}
                >
                  <svg width="14" height="14" viewBox="0 0 20 20" fill="none" className="ac-item-icon">
                    <path d="M10 1.25c-3.5 0-6.25 2.75-6.25 6.25 0 4.69 6.25 11.25 6.25 11.25s6.25-6.56 6.25-11.25c0-3.5-2.75-6.25-6.25-6.25z"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <HighlightMatch text={city} query={cityAC.inputValue} />
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* ── Autocomplete Spécialité ── */}
        <div className="ac-wrapper" ref={specAC.wrapperRef}>
          <div className="specialty-select-wrapper">
            <svg className="specialty-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 2a5 5 0 0 1 5 5v2h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h1V7a5 5 0 0 1 5-5zm0 9a1 1 0 0 0-1 1v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 0-1-1zm0-7a3 3 0 0 0-3 3v2h6V7a3 3 0 0 0-3-3z"
                fill="currentColor" />
            </svg>
            <input
              type="text"
              className="specialty-input"
              placeholder={t("doctorFinder.specialtyPlaceholder", "Spécialité…")}
              value={specAC.inputValue}
              onChange={(e) => specAC.handleChange(e.target.value)}
              onKeyDown={(e) => specAC.handleKeyDown(e, (s) => setSpecialty(s.id))}
              autoComplete="off"
            />
            {specAC.inputValue && (
              <button
                type="button"
                className="ac-clear-btn"
                onClick={() => { specAC.setInputValue(''); setSpecialty(''); }}
                aria-label="Effacer"
              >×</button>
            )}
          </div>
          {specAC.isOpen && (
            <ul className="ac-dropdown" role="listbox">
              {specAC.suggestions.map((spec, idx) => {
                const key = `doctorFinder.specialties.${spec.id}`;
                const translated = t(key);
                const displayLabel = translated !== key ? translated : spec.label;
                return (
                  <li
                    key={spec.id}
                    role="option"
                    aria-selected={idx === specAC.highlightedIndex}
                    className={`ac-item${idx === specAC.highlightedIndex ? ' ac-item--highlighted' : ''}`}
                    onMouseDown={() => specAC.selectItem({ ...spec, _displayLabel: displayLabel }, (s) => setSpecialty(s.id))}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="ac-item-icon">
                      <path d="M12 2a5 5 0 0 1 5 5v2h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h1V7a5 5 0 0 1 5-5zm0 9a1 1 0 0 0-1 1v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 0-1-1zm0-7a3 3 0 0 0-3 3v2h6V7a3 3 0 0 0-3-3z"
                        fill="currentColor" />
                    </svg>
                    <HighlightMatch text={displayLabel} query={specAC.inputValue} />
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        <button type="submit" className="find-doctor-btn">
          {t("doctorFinder.findButton")}
        </button>
      </form>
    </div>
  );
};

// ── Surligne la partie qui matche ────────────────────────────────────────────
function HighlightMatch({ text, query }) {
  if (!query) return <span>{text}</span>;
  const q = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const normalized = text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const idx = normalized.indexOf(q);
  if (idx === -1) return <span>{text}</span>;
  return (
    <span>
      {text.slice(0, idx)}
      <mark className="ac-highlight">{text.slice(idx, idx + query.length)}</mark>
      {text.slice(idx + query.length)}
    </span>
  );
}

export default SearchBarGroup;